import { AxiosError } from 'axios';

export const isForbiddenError = (error: AxiosError | undefined) => {
  return error?.response?.status === 403 ? true : false;
};
